import { render, staticRenderFns } from "./VideoTab.vue?vue&type=template&id=54628a06&"
import script from "./VideoTab.vue?vue&type=script&lang=js&"
export * from "./VideoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports